exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card__subtitle,.v-card__text,.v-card__title{padding:0!important}.v-card__title{font-size:18px}.v-tab--active{color:#ab3b7a!important}", ""]);

// exports
